import styled from '@tanium/react-emotion-9';

export const NoWrapText = styled('div')({
  whiteSpace: 'nowrap',
});
